"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _toJS = _interopRequireDefault(require("transmute/toJS"));

var _valueSeq = _interopRequireDefault(require("transmute/valueSeq"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Raven = _interopRequireDefault(require("Raven"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _BookingContainer = _interopRequireDefault(require("MeetingsLib/components/page/BookingContainer"));

var _BookingSummary = _interopRequireDefault(require("MeetingsLib/components/page/BookingSummary"));

var _Error = _interopRequireDefault(require("MeetingsLib/components/Error"));

var _utils = require("MeetingsLib/utils/utils");

var _analytics = require("MeetingsLib/utils/analytics");

var _hubspotGTMContainer = _interopRequireDefault(require("MeetingsLib/utils/hubspotGTMContainer"));

var _UsageTracker = require("MeetingsLib/tracking/UsageTracker");

var _NetworkErrorSelector = require("MeetingsLib/selectors/NetworkErrorSelector");

var _RequestStatusSelectors = require("MeetingsLib/selectors/RequestStatusSelectors");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _LocalizationSelectors = require("MeetingsLib/selectors/LocalizationSelectors");

var FormActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/FormActions"));

var BookActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/BookActions"));

var AvailabilityActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/AvailabilityActions"));

var UIActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/UIActions"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _DisplayInfo = _interopRequireDefault(require("MeetingsBase/models/DisplayInfo"));

var _BookingLifecycle = _interopRequireDefault(require("MeetingsLib/models/BookingLifecycle"));

var _enums = require("MeetingsBase/constants/enums");

var App = (0, _createReactClass.default)({
  displayName: "App",
  propTypes: {
    // passable props
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    displayInfo: _propTypes.default.instanceOf(_DisplayInfo.default).isRequired,
    hideLogo: _propTypes.default.bool,
    changeLocale: _propTypes.default.func,
    DatePickerMarker: _propTypes.default.func,
    TimePickerMarker: _propTypes.default.func,
    EmailFormMarker: _propTypes.default.func,
    NotFoundMarker: _propTypes.default.func,
    ErrorMarker: _propTypes.default.func,
    // props from store (don't change these)
    bookInfoError: _propTypes.default.string,
    bookingLifecycle: _propTypes.default.instanceOf(_BookingLifecycle.default).isRequired,
    companyName: _propTypes.default.string,
    embedded: _propTypes.default.bool.isRequired,
    isInvalidDomainError: _propTypes.default.bool,
    isSalesStarter: _propTypes.default.bool,
    offline: _propTypes.default.bool,
    activeLocale: _propTypes.default.string,
    onSuccess: _propTypes.default.func.isRequired,
    onFailure: _propTypes.default.func.isRequired,
    parentPageHSAnalyticsInfo: _propTypes.default.instanceOf(Object),
    portalId: _propTypes.default.number.isRequired,
    profile: _propTypes.default.instanceOf(_UserProfile.default).isRequired,
    userTimezone: _propTypes.default.string,
    formGuid: _propTypes.default.string,
    linkType: _propTypes.default.oneOf((0, _valueSeq.default)(_enums.LINK_TYPES).toArray()),
    contentTracking: _propTypes.default.object,
    redirectUrl: _propTypes.default.string,
    allowRedirect: _propTypes.default.bool.isRequired,
    // action dispatchers
    getAvailability: _propTypes.default.func.isRequired,
    // request statuses
    bookingPageLoading: _propTypes.default.bool.isRequired,
    submittingMeeting: _propTypes.default.bool.isRequired,
    shouldRenderBookingPage: _propTypes.default.bool.isRequired,
    meetingCreationSuccess: _propTypes.default.bool.isRequired,
    fetchBookInfoFailed: _propTypes.default.bool.isRequired,
    meetingsUserFetchStarted: _propTypes.default.bool.isRequired,
    meetingsUserFetchSuccess: _propTypes.default.bool.isRequired,
    meetingCreationFailed: _propTypes.default.bool.isRequired,
    availabilityFetchFailed: _propTypes.default.bool.isRequired,
    availabilityFetchSuccess: _propTypes.default.bool.isRequired,
    initTrackingForMeetings: _propTypes.default.bool.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      DatePickerMarker: function DatePickerMarker() {
        return null;
      },
      TimePickerMarker: function TimePickerMarker() {
        return null;
      },
      EmailFormMarker: function EmailFormMarker() {
        return null;
      },
      NotFoundMarker: function NotFoundMarker() {
        return null;
      },
      ErrorMarker: function ErrorMarker() {
        return null;
      }
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    var _this$props = this.props,
        getAvailability = _this$props.getAvailability,
        changeLocale = _this$props.changeLocale;
    getAvailability(changeLocale);
    (0, _analytics.trackLibVersionInNewRelic)();
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this$props2 = this.props,
        previousFormGuid = _this$props2.formGuid,
        initTrackingForMeetings = _this$props2.initTrackingForMeetings,
        __oldPortalId = _this$props2.portalId,
        __oldCompanyName = _this$props2.companyName,
        oldAvailabilityFetchSuccess = _this$props2.availabilityFetchSuccess,
        __oldLinkType = _this$props2.linkType,
        __oldContentTracking = _this$props2.contentTracking,
        __activeLocale = _this$props2.activeLocale;
    var profile = nextProps.profile,
        headline = nextProps.displayInfo.headline,
        availabilityFetchSuccess = nextProps.availabilityFetchSuccess,
        portalId = nextProps.portalId,
        linkType = nextProps.linkType,
        nextFormGuid = nextProps.formGuid,
        nextContentTracking = nextProps.contentTracking,
        embedded = nextProps.embedded,
        companyName = nextProps.companyName,
        activeLocale = nextProps.activeLocale;
    var availabilityInfoLoaded = availabilityFetchSuccess && availabilityFetchSuccess !== oldAvailabilityFetchSuccess;

    if (availabilityInfoLoaded) {
      (0, _hubspotGTMContainer.default)(portalId);
    }

    if (availabilityInfoLoaded && initTrackingForMeetings) {
      (0, _UsageTracker.initializeMeetingsLibTracker)(nextProps.profile.email, portalId, embedded, activeLocale);
      (0, _UsageTracker.track)('meetingsLibLoaded');
    }

    var shouldSetDocumentTitle = this.shouldSetDocumentTitle(availabilityFetchSuccess, embedded);

    if (shouldSetDocumentTitle) {
      (0, _utils.setDocumentTitle)(headline, linkType, companyName, profile);
    }

    var shouldTrackFormViews = this.shouldTrackFormViews(previousFormGuid, nextFormGuid);

    if (shouldTrackFormViews && availabilityFetchSuccess) {
      (0, _analytics.trackHsFormViews)(nextFormGuid, portalId, Object.assign({}, this.props.parentPageHSAnalyticsInfo, {}, nextContentTracking), embedded);
      (0, _analytics.addHsTrackingCode)(portalId, embedded);
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var availabilityFetchDidFail = prevProps.availabilityFetchFailed;
    var _this$props3 = this.props,
        availabilityFetchFailed = _this$props3.availabilityFetchFailed,
        bookInfoError = _this$props3.bookInfoError;

    if (!availabilityFetchDidFail && availabilityFetchFailed) {
      (0, _UsageTracker.track)('meetingsLibViewScreen', {
        stage: 'generic error page'
      });

      _Raven.default.captureBreadcrumb({
        message: 'Public availability info fetch failed!',
        data: {
          error: bookInfoError
        }
      });
    }
  },
  shouldSetDocumentTitle: function shouldSetDocumentTitle(availabilityFetchSuccess, embedded) {
    var meetingsLinkExists = availabilityFetchSuccess;
    return !embedded && meetingsLinkExists;
  },
  shouldTrackFormViews: function shouldTrackFormViews(previousFormGuid, nextFormGuid) {
    return previousFormGuid !== nextFormGuid;
  },
  renderBookingContainer: function renderBookingContainer() {
    var _this$props4 = this.props,
        branding = _this$props4.branding,
        hideLogo = _this$props4.hideLogo,
        profile = _this$props4.profile,
        submittingMeeting = _this$props4.submittingMeeting,
        _this$props4$displayI = _this$props4.displayInfo,
        avatar = _this$props4$displayI.avatar,
        headline = _this$props4$displayI.headline,
        DatePickerMarker = _this$props4.DatePickerMarker,
        TimePickerMarker = _this$props4.TimePickerMarker,
        EmailFormMarker = _this$props4.EmailFormMarker;
    return _react.default.createElement(_BookingContainer.default, {
      avatar: avatar,
      branding: branding,
      headline: headline,
      hideLogo: hideLogo,
      profile: profile,
      submittingMeeting: submittingMeeting,
      DatePickerMarker: DatePickerMarker,
      TimePickerMarker: TimePickerMarker,
      EmailFormMarker: EmailFormMarker
    });
  },
  renderSummary: function renderSummary() {
    var _this = this;

    var _this$props5 = this.props,
        bookingLifecycle = _this$props5.bookingLifecycle,
        branding = _this$props5.branding,
        _this$props5$displayI = _this$props5.displayInfo,
        avatar = _this$props5$displayI.avatar,
        headline = _this$props5$displayI.headline,
        embedded = _this$props5.embedded,
        isSalesStarter = _this$props5.isSalesStarter,
        offline = _this$props5.offline,
        profile = _this$props5.profile,
        userTimezone = _this$props5.userTimezone,
        redirectUrl = _this$props5.redirectUrl,
        allowRedirect = _this$props5.allowRedirect,
        portalId = _this$props5.portalId;
    var bookedDateTime = bookingLifecycle.postResponse.get('timerange').start;
    return _react.default.createElement(_BookingSummary.default, {
      bookingLifecycle: bookingLifecycle,
      avatar: avatar,
      bookedDateTime: bookedDateTime,
      branding: branding,
      embedded: embedded,
      headline: headline,
      isSalesStarter: isSalesStarter,
      offline: offline,
      profile: profile,
      userTimezone: userTimezone,
      redirectUrl: redirectUrl,
      allowRedirect: allowRedirect,
      onSuccess: function onSuccess() {
        parent.postMessage({
          meetingBookSucceeded: true
        }, '*');

        _this.props.onSuccess((0, _toJS.default)(bookingLifecycle.postResponse));
      },
      portalId: portalId
    });
  },
  renderError: function renderError(profile) {
    var _this2 = this;

    var _this$props6 = this.props,
        bookingLifecycle = _this$props6.bookingLifecycle,
        fetchBookInfoFailed = _this$props6.fetchBookInfoFailed,
        meetingsUserFetchSuccess = _this$props6.meetingsUserFetchSuccess,
        meetingCreationFailed = _this$props6.meetingCreationFailed,
        bookInfoError = _this$props6.bookInfoError,
        isInvalidDomainError = _this$props6.isInvalidDomainError,
        NotFoundMarker = _this$props6.NotFoundMarker,
        ErrorMarker = _this$props6.ErrorMarker;
    return _react.default.createElement(_Error.default, {
      profile: profile,
      bookInfoError: bookInfoError,
      isInvalidDomainError: isInvalidDomainError,
      meetingCreationFailed: meetingCreationFailed,
      bookInfoFailed: fetchBookInfoFailed,
      meetingsUserFetchSuccess: meetingsUserFetchSuccess,
      NotFoundMarker: NotFoundMarker,
      ErrorMarker: ErrorMarker,
      onFailure: function onFailure() {
        parent.postMessage({
          meetingBookFailed: true
        }, '*');

        _this2.props.onFailure((0, _toJS.default)(bookingLifecycle.postResponse));
      }
    });
  },
  renderApplication: function renderApplication() {
    var _this$props7 = this.props,
        profile = _this$props7.profile,
        bookingPageLoading = _this$props7.bookingPageLoading,
        meetingsUserFetchStarted = _this$props7.meetingsUserFetchStarted,
        shouldRenderBookingPage = _this$props7.shouldRenderBookingPage,
        meetingCreationSuccess = _this$props7.meetingCreationSuccess,
        availabilityFetchFailed = _this$props7.availabilityFetchFailed;

    if (shouldRenderBookingPage && !availabilityFetchFailed) {
      return this.renderBookingContainer();
    }

    if (bookingPageLoading || meetingsUserFetchStarted) {
      return _react.default.createElement(_UILoadingSpinner.default, {
        layout: "centered"
      });
    }

    if (meetingCreationSuccess) {
      return this.renderSummary();
    }

    return this.renderError(profile);
  },
  render: function render() {
    var embedded = this.props.embedded;
    var className = 'meetings-lib' + (embedded ? " embedded" : "");
    return _react.default.createElement("div", {
      className: className
    }, this.renderApplication());
  }
});

var _default = (0, _reactRedux.connect)(function (state, props) {
  return {
    linkType: (0, _BookInfoSelectors.getBookInfo)(state).linkType,
    formGuid: (0, _BookInfoSelectors.getBookInfo)(state).formGuid,
    contentTracking: (0, _BookInfoSelectors.getBookInfo)(state).contentTracking,
    offline: (0, _BookInfoSelectors.getOffline)(state),
    branding: props.branding || state.branding,
    portalId: state.portalId,
    profile: (0, _BookInfoSelectors.getUserProfile)(state, props),
    companyName: state.companyName,
    bookingLifecycle: state.bookingLifecycle,
    userTimezone: state.userTimezone,
    bookInfoError: (0, _NetworkErrorSelector.getBookInfoError)(state),
    isInvalidDomainError: (0, _NetworkErrorSelector.isInvalidDomainError)(state),
    initTrackingForMeetings: state.initTrackingForMeetings,
    activeLocale: (0, _LocalizationSelectors.getActiveLocale)(state),
    onSuccess: state.onSuccess,
    onFailure: state.onFailure,
    embedded: state.embedded,
    displayInfo: (0, _BookInfoSelectors.getDisplayInfo)(state, props),
    redirectUrl: (0, _BookInfoSelectors.getCustomParams)(state).redirectUrl,
    allowRedirect: state.allowRedirect,
    isSalesStarter: state.isSalesStarter,
    parentPageHSAnalyticsInfo: state.parentPageHSAnalyticsInfo,
    // request statuses
    meetingCreationSuccess: (0, _RequestStatusSelectors.meetingCreationSuccess)(state),
    bookingPageLoading: (0, _RequestStatusSelectors.bookingPageLoading)(state),
    shouldRenderBookingPage: (0, _RequestStatusSelectors.shouldRenderBookingPage)(state),
    fetchBookInfoFailed: (0, _RequestStatusSelectors.fetchBookInfoFailed)(state),
    meetingCreationFailed: (0, _RequestStatusSelectors.meetingCreationFailed)(state),
    availabilityFetchFailed: (0, _RequestStatusSelectors.availabilityFetchFailed)(state),
    availabilityFetchSuccess: (0, _RequestStatusSelectors.availabilityFetchSuccess)(state),
    meetingsUserFetchStarted: (0, _RequestStatusSelectors.meetingsUserFetchStarted)(state),
    meetingsUserFetchSuccess: (0, _RequestStatusSelectors.meetingsUserFetchSuccess)(state),
    submittingMeeting: (0, _RequestStatusSelectors.isSubmittingMeeting)(state)
  };
}, Object.assign({}, FormActions, {}, BookActions, {}, UIActions, {}, AvailabilityActions))(App);

exports.default = _default;
module.exports = exports.default;